'use strict';
var React = require('react');
var assetsHelper = require('../../helper/assetsHelper');
var graphicsHelper = require('../../helper/graphicsHelper');

var LineChart = React.createClass({
  render: function () {

    return (
      <div className="border">
        <img width='100%' height='100%' src={assetsHelper.getComponentAsset('lineChart')} alt=""/>
      </div>
    )
  }
});

module.exports = LineChart;



// WEBPACK FOOTER //
// ./src/views/Components/LineChart.jsx